import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as LogoWalletConnect } from '@pkg/assets/icons/v2/wallet-connect.svg';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { Sizes } from '@pkg/components/Sections/Profile/Buttons/Button/types';
import { useConnectWalletConnect } from '@pkg/hooks/wallets';

import { useLegacyWalletStore } from '@app/store/zustand';

import { type CommonWalletButtonProps } from './types';

export type ButtonWalletConnectProps = CommonWalletButtonProps;

export function ButtonWalletConnect({
    color,
    size = Sizes.medium,
    fluid = false,
    showIcon = false,
}: ButtonWalletConnectProps) {
    const [translate] = useTranslation('wallet');

    const { setConnecting } = useLegacyWalletStore();
    const { connect: connectWalletConnect } = useConnectWalletConnect();

    function handleNewConnection() {
        setConnecting({ type: 'wallet-connect', step: 'awaiting-external-action' });
        connectWalletConnect();
    }

    return (
        <Button
            variant="solid"
            color={color}
            size={size}
            fluid={fluid}
            startIcon={showIcon ? <LogoWalletConnect /> : null}
            onClick={handleNewConnection}
        >
            {translate('name-wallet-connect')}
        </Button>
    );
}
